/** Общая сетка: сайдбар разделов + контент. [&>*]:min-w-0 — иначе grid-item не сжимается ниже контента. */
export const WORKSPACE_SHELL_GRID = "grid min-w-0 grid-cols-1 gap-6 [&>*]:min-w-0 lg:grid-cols-[14rem_minmax(0,1fr)] xl:grid-cols-[15rem_minmax(0,1fr)] 2xl:grid-cols-[16rem_minmax(0,1fr)] lg:items-start";
export const WORKSPACE_ASIDE = "hidden rounded-xl border border-border bg-card p-4 shadow-sm lg:sticky lg:top-20 lg:block";
/**
 * Горизонтальный скролл широких таблиц внутри карточки.
 * min-w-0 + max-w-full обязательны: иначе обёртка растягивается вместе с table.min-w-*
 * и scrollbar оказывается за пределами viewport (контент просто обрезается).
 */
export const TABLE_SCROLL = "min-w-0 w-full max-w-full overflow-x-auto overscroll-x-contain";
